import { isAffirmative } from "@/utils/isAffirmative/isAffirmative";
// Turning Custom EAP off in CORE keeps the saved numbers in the response, so the
// flag decides whether they apply. Empty means the booking journey shows its default line.
export const extractEapPhoneNumbers = (response) => {
    const customisation = response?.success ? response.eap_customisation : null;
    if (!customisation || !isAffirmative(customisation.custom_eap))
        return [];
    const phones = customisation.defaults?.eap_phone;
    if (!Array.isArray(phones))
        return [];
    return phones.map(([label, encodedNumber]) => [
        label,
        decodeURIComponent(encodedNumber),
    ]);
};
